import { DashboardBaseFilterModel } from '@/dashboard/models/DashboardBaseFilterModel'

export class DashboardAmountOfMoneyEarnedFilterModel extends DashboardBaseFilterModel {
    constructor(d?:Partial<DashboardAmountOfMoneyEarnedFilterModel>) {
        super(d)
    }
}

